import { render, staticRenderFns } from "./ProductCardContainer.vue?vue&type=template&id=fd897612&"
import script from "./ProductCardContainer.vue?vue&type=script&lang=js&"
export * from "./ProductCardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports